var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-pop"},[_c('div',[_vm._v("\n    "+_vm._s(_vm.value.msg)+"\n  ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.value.info && _vm.value.info !== '')?_c('div',[_c('pre',[_vm._v("      "+_vm._s(_vm.value.info)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538d095a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop/CheckPop.vue
// module id = null
// module chunks = 